import script from "./AllH5Ads.vue?vue&type=script&setup=true&lang=ts"
export * from "./AllH5Ads.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__